import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService, ResponseObject } from '../auth.service';
import { ServiceBase } from '../service.base';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GalleryProductService extends ServiceBase {

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }

  public getAllGalleryProduct(): Observable<GalleryPersonlaProduct[]> {
    const httpOptions = this.RequestHeaders();
    const api = '/GalleryProduct';
    const method = '/fetchAllProducts';
    const url = environment.BASE_API_PATH + api + method;
    return this.http.get<GalleryPersonlaProduct[]>(url, httpOptions);
  }

  public getGalleryProductById(productId: string): Observable<GalleryPersonlaProduct> {
    const httpOptions = this.RequestHeaders();
    const api = '/GalleryProduct';
    const method = '/fetchProductById/' + productId;
    const url = environment.BASE_API_PATH + api + method;
    return this.http.get<GalleryPersonlaProduct>(url, httpOptions);
  }

  public createGalleryProduct(galleryData: GalleryPersonlaProduct): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const api = '/GalleryProduct';
    const method = '/save';
    const url = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, galleryData, httpOptions);
  }

  public getGalleryProductImages(galleryProductId: string): Observable<getGalleryProductImages[]> {
    const httpOptions = this.RequestHeaders();
    const method = `/GalleryProduct/${galleryProductId}/fetch-additional-images`;
    const url = environment.BASE_API_PATH + method;
    return this.http.get<getGalleryProductImages[]>(url, httpOptions);
  }

  public updateGalleryProductCoverPhoto(GalleryImgdata: GalleryCoverPhoto): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method = `/GalleryProduct/setCoverPhoto`;
    const url = environment.BASE_API_PATH + method;
    return this.http.post<ResponseObject>(url, GalleryImgdata, httpOptions);
  }

  public connectUploadedImages(galleryProductId: string | null, imageUrls: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method = `/GalleryProduct/${galleryProductId}/upload-additional-images`;
    const url = environment.BASE_API_PATH + method;
    return this.http.post<ResponseObject>(url, { galleryProductId, ImageUrl: imageUrls }, httpOptions);
  }

  public deleteGalleryProductById(productId: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method = `/GalleryProduct/deleteByProductId/${productId}`;
    const url = environment.BASE_API_PATH + method;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public deleteAdditionalImage(id: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method = `/GalleryProduct/${id}/delete-additional-image`;
    const url = environment.BASE_API_PATH + method;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }
}

export interface GalleryPersonlaProduct {
  Id: string;
  GalleryProductId: string;
  SerialNumber: string;
  SuggestedSalePrice: number;
  GalleryId: string;
  Name: string;
  ShortDescription: string;
  LongDescription: string;
  SocialMediaDescription: string;
  ProductImgUrl: string;
  Length: number;
  Width: number;
  Height: number;
  Weight: number;
  CostPrice: number;
  RetailPrice: number;
  IsSold: number;
  SoldDate: Date;
  SoldPrice: number;
  SoldInfo: string;
  ArtistName: string
}

export interface GalleryCoverPhoto {
  ProductId: string;
  CoverImageUrl: string;
}

export interface getGalleryProductImages {
  Id: string;
  ImageUrl: string;
  GalleryProductId: string;
  IsGalleryImg: boolean;
  hovered: boolean;
}
